import { render, staticRenderFns } from "./ed-create-subdeck-object.vue?vue&type=template&id=029e740a&scoped=true&"
import script from "./ed-create-subdeck-object.ts?vue&type=script&lang=ts&"
export * from "./ed-create-subdeck-object.ts?vue&type=script&lang=ts&"
import style0 from "./ed-create-subdeck-object.scss?vue&type=style&index=0&id=029e740a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029e740a",
  null
  
)

export default component.exports